import { z } from 'zod';
import { mediaNodeSchema } from '../../collection-subtitles/media-node';

export const fetchTreeResponseSchema = z.array(mediaNodeSchema);

export type IFetchTreeResponse = z.infer<typeof fetchTreeResponseSchema>;
